import { render, staticRenderFns } from "./StaffDetail.vue?vue&type=template&id=085aface"
import script from "./StaffDetail.vue?vue&type=script&lang=js"
export * from "./StaffDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports